import React from 'react';
import SalovareWordmark from './brand/SalovareWordmark';

const SalovareLogo = ({ sx }) => (
  <SalovareWordmark
    sx={{
      width: '100%',
      maxWidth: { xs: 200, sm: 230 },
      height: 'auto',
      marginBottom: '1.5rem',
      ...sx
    }}
  />
);

export default SalovareLogo;
